// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"SkewedTooltip_tooltip_pDmHW"};